<template>
  <div>
    <v-row>
      <v-col>
        <vue-tel-input-vuetify
          label="Your phone number"
          hint="The phone number at which you wish to receive verification codes"
          @validate="phoneNumberValidated"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col>
        <auth-recaptcha
          @solved="captchaSolved"
          @expired="captchaExpired"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col class="text-right">
        <v-btn
          color="primary"
          :disabled="!canVerify"
          :loading="sending"
          @click="sendVerificationCode"
        >
          Send verification code
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AuthRecaptcha from '@/components/auth/AuthRecaptcha'
import { verifyNewPhoneNumber } from '@/utils/mfa'
import { AUTH_CAPTCHA_EXPIRED } from '@/utils/auth'

export default {
  name: 'EnableMfaPhoneNumber',
  components: {
    AuthRecaptcha
  },
  emits: ['phoneNumberVerified', 'error'],
  data: function () {
    return {
      phoneNumberValid: false,
      phoneNumber: null,
      recaptchaVerifier: null,
      sending: false
    }
  },
  computed: {
    canVerify() {
      return this.phoneNumberValid && this.recaptchaVerifier
    }
  },
  methods: {
    phoneNumberValidated(event) {
      this.phoneNumberValid = event.isValid
      if (event.isValid) {
        this.phoneNumber = event.number.international
      }
    },
    captchaSolved(recaptchaVerifier) {
      this.recaptchaVerifier = recaptchaVerifier
    },
    captchaExpired() {
      this.recaptchaVerifier = null
      const expiredError = new Error('ReCAPTCHA expired')
      expiredError.code = AUTH_CAPTCHA_EXPIRED
      this.$emit('error', expiredError)
    },
    async sendVerificationCode() {
      try {
        this.sending = true
        const verificationId = await verifyNewPhoneNumber({
          phoneNumber: this.phoneNumber,
          recaptchaVerifier: this.recaptchaVerifier
        })
        this.$emit('phoneNumberVerified', verificationId)
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
